import { FCX } from "@datassential/platform-ui-lib";
import './Widget.scss';
import { ReactNode } from "react";
import cn from "classnames";

const Widget: FCX<{
    headerContent?: ReactNode;
}> = ({
    headerContent,
    children,
    className,
    style,
    testId
}) => {
    return (
        <div
            className={cn("Widget", className)}
            data-testid={testId}
            style={style}
        >
            {headerContent && (
                <div
                    className="Widget__header"
                    // data-testid="blockWidgetHeader"
                >
                    {headerContent}
                </div>
            )}
            <div
                className="Widget__content"
                // data-testid="blockWidgetContent"
            >
                {children}
            </div>
        </div>
    );
};

export default Widget;